import React, { useContext, useEffect, useRef, useState } from "react";
import "./area-top.scss";
import { MdOutlineMenu } from "react-icons/md";
import { SidebarContext } from "../../../context/side-bar-context";
import { SidebarContextType } from "../../../types/sidebar";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { addDays } from "date-fns"; // theme css file
import { DateRange } from "react-date-range";

const speed = 30;

const text =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.";

const AreaTop = () => {
  const { openSideBar } = useContext(SidebarContext) as SidebarContextType;

  return (
    <section className="content-area-top">
      <div className="area-top-l">
        <button
          type="button"
          className="sidebar-close-btn"
          onClick={openSideBar}
        >
          <MdOutlineMenu size={24} />
        </button>
        <h2 className="area-top-title">Dashboard</h2>
        <div className="marquee">
          <div className="marquee-text">
            <p>{text}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AreaTop;
